var map = {
	"./AI_Analysis_en.mp4": 50737,
	"./AI_Analysis_zh.mp4": 46764,
	"./AddToDictionary_en_US.mp4": 10794,
	"./AddToDictionary_zh.mp4": 53428,
	"./Memo_en.mp4": 9342,
	"./Memo_zh.mp4": 48237,
	"./ReplaceAll_en_US.mp4": 41123,
	"./ReplaceAll_zh.mp4": 81029,
	"./TimestamppedWord_en_US.mp4": 80540,
	"./TimestamppedWord_zh.mp4": 58165,
	"./Trim_Chinese.mp4": 57808,
	"./Trim_Cut_en.mp4": 42710,
	"./Trim_Cut_zh.mp4": 63010,
	"./Trim_English.mp4": 40223,
	"./about/aiassist_en_US.mp4": 60737,
	"./about/aiassist_zh.mp4": 5532,
	"./about/export_en_US.mp4": 17798,
	"./about/export_zh.mp4": 92842,
	"./about/translate_en_US.mp4": 29478,
	"./about/translate_zh.mp4": 88144,
	"./about/upload_en_US.mp4": 1617,
	"./about/upload_zh.mp4": 43477,
	"./landing_ch.mp4": 13562,
	"./landing_en.mp4": 47593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14239;